import * as Sentry from '@sentry/react';

const init = () => {
  Sentry.init({
    debug: true,
    environment: process.env.REACT_APP_ENV,
    dsn: process.env.REACT_APP_SENTRY_DSN,
    integrations: [],
  });
};

const setRoom = (room_id: string) => {
  Sentry.setTag('room', room_id);
};

const setUser = (user_id: string) => {
  Sentry.setUser({
    id: user_id,
    ip_address: '{{auto}}',
  });
};

const setAnonymousUser = (username: string) => {
  Sentry.setUser({
    username,
    ip_address: '{{auto}}',
  });
};

const captureError = (err: Error | string) => {
  console.error('PUBLISHING TO SENTRY', err);
  let error = err;
  if (typeof err === 'string') error = new Error(err);
  Sentry.captureException(error);
};

const captureMessage = (msg: string) => {
  console.log('PUBLISHING TO SENTRY', msg);
  Sentry.captureMessage(msg || '');
};

export default {
  init,
  setRoom,
  setUser,
  setAnonymousUser,
  captureError,
  captureMessage,
};
